import { delay } from '@shared/utils/async';
import { HttpEndpoint } from '@/api/httpEndpoints';
import { AuthenticateEndpoint as AuthenticateEndpointModel } from './authenticate.interfaces';

export class AuthenticateEndpoint extends HttpEndpoint implements AuthenticateEndpointModel {
    public constructor(applicationUrl: string) {
        super(applicationUrl);
    }

    public InitiateVerification(): Promise<any> {
        return this.get('mvc/Authenticate/InitiateAccountValidation');
    }
}

export class FakeAuthenticateEndpoint implements AuthenticateEndpointModel {
    public async InitiateVerification(): Promise<any> {
        await delay(1000);
        return '';
    }
}
